import React, { useContext, useEffect, useState } from 'react';
import {Form, Input, InputNumber, Popconfirm, Table ,Typography ,ConfigProvider} from 'antd';
import LK_Delete from '../../../../images/LK_Delete';
import '../../../../cssfiles/homepage.css';
import CustomCheckbox from '../../../CommonComponents/CustomCheckbox';
import CustomDropDown from '../../../CommonComponents/CustomDropDown';
import CustomTextField from '../../../CommonComponents/CustomTextField';
import {Box,Button} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LK_Add from '../../../../images/LK_Add';
import LK_Search from '../../../../images/LK_Search';
import LK_Close from '../../../../images/LK_Close';
import CustomDialogBox from '../../../CommonComponents/CustomDialogBox';
import CustomExportButton from '../../../CommonComponents/CustomExportButton';
import CustomImportButton from '../../../CommonComponents/CustomImportButton';
import {librarytagdelete} from "../../../../Restclient/datacollection";
import LK_Loading from '../../../../images/LK_Loading.gif';
import CustomTooltip from '../../../CommonComponents/CustomTooltip';
import { ThemeContext } from "../../../../pages/Homepage";

export default function EditableTableLibrary({data,setdata,deviceId,_enabled,_connstate,getdeleteTags, units, datatypes ,storageGroupsList}) {

  const { theme } = useContext(ThemeContext);

  const [tabvalue, setTabvalue] = useState('Parameter List');
  const Maintablist = ['Parameter List']; //, 'Live Data'
  const [maintabs, _setMaintabs] = useState(Maintablist);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [operation,setOperation] = useState(0);
  const [ifsearching, setifSearching] = useState(0);
  const [searchList,setsearchList] = React.useState([]);
  const [search, setSearch] = useState({searchText:"",filterSelected:""});
  const filter=['Storage Enabled','Storage Disabled','Active Enabled','Active Disabled'];
  const filterMap = {storage:'Storage',active:'Active'};
  const [deleteTags,setdeleteTags] = useState(0);
  const [ifloading,setifLoading] = useState(0);
  const [required,setRequired] = useState(0); 
  const isEditing = record => record.key === editingKey;
 
  // const parameters = data.length>0?data:[{tagId:"",key: 0,parameter: '',description:"",payloadName:"",datatype: '',timestamp: '',alias: '',value:'',unit: '',active: false,storage: false,storageId:[]}]
  const parameters = data.length>0?data:[]
  const [dataSource, setDataSource] = useState(parameters);
  const [activeParameter,setActiveParameter] = useState(parameters);
  const unitsList= units;
  const dataTypesList = datatypes;
  const storageGroups = ['none' , ...storageGroupsList.map(item => item.GroupName)];

  const unit0 = unitsList[0]==="NA"?" ":unitsList[0];
  const [editRow,setEditRow] = useState([{tagId:"",key: 0 ,parameter: '',datatype: dataTypesList[0][0],description: '',alias: '',unit: unit0,payloadName:'',value:'',timestamp: '',active: false,storage: false,storageGroupid:'',scalingFactor:''}]);

  const defaultColumns = [
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      width: '12.4%',
      // editable: true,
      // render:(text,record,index)=>{ 
      //   return(
      //     <CustomDropDown data={list} selected={handleSelectedParameter} defaultValue={list[0]}/>
      //   )
      // }
      render: (_, record,index) =>
      {
        const editable = isEditing(record);
        function handleParameterName(selected){
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].parameter = selected.toString();

          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].parameter = selected.toString();
          setEditRow(editRow);
        }
        return editable ? (
          <>
            <CustomTextField maxLength={250}onChange={handleParameterName} defaultValue={editRow[0].parameter} permittedCharacters={'^[a-zA-Z][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"} width={160}/>
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>{record.parameter}</Typography>
        );
      }
    },
    {
      title: 'Description',
      width: '16%',
      dataIndex: 'description',
      // editable: true,
      render: (_, record,index) =>
      {
        const editable = isEditing(record);
        function handleDescription(selected){
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].description = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].description = selected.toString();
          setEditRow(editRow);
        }
        return editable ? (
          <>
            <CustomTextField maxLength={250}onChange={handleDescription} defaultValue={editRow[0].description} width={220}/>
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>{record.description}</Typography>
        );
      }
    },
    {
      title: 'Alias',
      dataIndex: 'alias',
      width: '9%',
      // editable: true,
      render: (_, record,index) =>
      {
        const editable = isEditing(record);
        function handleAlias(selected){
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].alias = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          editRow[0].alias = selected.toString();
          setEditRow(editRow);
          
        }
        return editable ? (
          <CustomTextField maxLength={250} onChange={handleAlias} defaultValue={editRow[0].alias} permittedCharacters={'^[a-zA-Z][a-zA-Z0-9_]*$'} errorText={"Only alphanumeric characters are allowed"} width={"120px"}/>
        ) : (
          <Typography>{record.alias}</Typography>
        );
      }
    },
    {
      title: 'Data Type',
      dataIndex: 'datatype',
      width: '10%',
      // editable: true,
      render: (_, record,index) =>
      {
        const editable = isEditing(record);
        function handleDataTypeChange(selected){
          // dataSource.
          // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
          // updatedDataSource[index].datatype = selected.toString();
          // setDataSource(updatedDataSource);
          const updatedRow = JSON.parse(JSON.stringify(editRow));
          dataTypesList[1].forEach((item,index) => {
            if(item===selected){
              editRow[0].datatype = dataTypesList[0][index].toString();
            }
          })
          // editRow[0].datatype = selected.toString();
          setEditRow(editRow);
        }

        function handleDataTypeName(selected){
          let name =""
          dataTypesList[0].forEach((item,index) => {
            if(item===selected){
              name = dataTypesList[1][index].toString();
            }
          })
          return name;
        }

        return editable ? (
          <>
            <CustomDropDown options={dataTypesList[1]} onChange={handleDataTypeChange} defaultValue={handleDataTypeName(editRow[0].datatype)} width={"125px"}></CustomDropDown>  
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </>
        ) : (
          <Typography>{handleDataTypeName(record.datatype)}</Typography>
        );
      }
    },
    // {
    //   title: 'Value',
    //   dataIndex: 'value',
    //   editable: true,
    // },
    // {
    //   title: 'Timestamp',
    //   dataIndex: 'timestamp',
    //   editable: true,
    // },\
    {
      title: 'Payload Name',
      dataIndex: 'payloadName',
      width: '13.4%',
      // editable: true,
      render: (_, record,index) =>
        {
          const editable = isEditing(record);
          function handlePayloadName(selected){
            // dataSource.
            // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
            // updatedDataSource[index].payloadName = selected.toString();
            // setDataSource(updatedDataSource);
            const updatedRow = JSON.parse(JSON.stringify(editRow));
            editRow[0].payloadName = selected.toString();
            setEditRow(editRow);
          }

          return editable ? (
            <>
              <CustomTextField maxLength={250} onChange={handlePayloadName} defaultValue={editRow[0].payloadName} permittedCharacters={'^[a-zA-Z][a-zA-Z0-9_\\.]*$'} errorText={"Only alphanumeric characters are allowed"} width={"160"}/>
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            </>
          ) : (
            <Typography>{record.payloadName}</Typography>
          );
        }
    },
    {
        title: 'Unit',
        dataIndex: 'unit',
        width: '8.2%',
        // editable: true,
        render: (_, record,index) =>
        {
          const editable = isEditing(record);
          function handleUnitChange(selected){
            // dataSource.
            // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
            // updatedDataSource[index].unit = selected.toString();
            // setDataSource(updatedDataSource);
            const updatedRow = JSON.parse(JSON.stringify(editRow));
            if(selected==="NA"){
              editRow[0].unit = " ";
            }else{
              editRow[0].unit = selected.toString();
            }
            setEditRow(editRow);
          }

          return editable ? (
            <>
              <CustomDropDown options={unitsList} onChange={handleUnitChange} defaultValue={editRow[0].unit===" "?"NA":editRow[0].unit} width={"100px"}></CustomDropDown>  
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            </>
          ) : (
            <Typography>{record.unit===" "?"NA":record.unit}</Typography>
          );
        }
    },
    {
      title: 'Scaling Factor',
      dataIndex: 'scalingFactor',
      width: '9%',
      // editable: true,
      render:(_text,record,index)=>{

        const editable = isEditing(record);

        function handleScalingFactor(selected){
            editRow[0].scalingFactor = selected;
            setEditRow(editRow);
        }


        return(
          <Box sx={{display:"flex",flexDirection:"row", gap:'12px'}}>
            {editable ? (
              <>
                <CustomTextField maxLength={250} onChange={handleScalingFactor} defaultValue={editRow[0].scalingFactor} permittedCharacters={'^[0-9][0-9\\.]*$'} errorText={"Only numeric characters are allowed"} width={"160"}/>
              </>
            ) : (
              <Typography>{record.scalingFactor}</Typography>
            )
            }
          </Box>
        )
      }
    },
    {
        title: 'Storage',
        dataIndex: 'storage',
        width: '12%',
        // editable: true,
        render:(_text,record,index)=>{
 
          const editable = isEditing(record);
          function handleStorageCheck(selected){
            // dataSource.
            // if(selected==true){
            //   setifStorage(1);
            //   setStorageIndex(index);
            // }
            // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
            // updatedDataSource[index].storage = selected.toString();
            // setDataSource(updatedDataSource);
            const updatedRow = JSON.parse(JSON.stringify(editRow));
            let temp = [...editRow];
            temp[0].storage = selected.toString();
            setEditRow(temp);
            // if(selected===true){
            //   setifStorage(1);
            //   setStorageIndex(index);
            // }
          }

          function handleStorageGroupChange(selected){
            if(selected!=='none'){
              let opt = handleStorageGroupOptions(storageGroups);
              let index = opt.indexOf(selected);
              // let id = storageGroupsList.filter(item => item.GroupName === selected)
              let id = []
              if(index!==-1){
                id = storageGroupsList[index-1]
              }
              if(id.length===0){
                editRow[0].storageGroupid = "";
              }
              else{
                editRow[0].storageGroupid = id.GroupID;
              }
            }
            else{
              editRow[0].storageGroupid = "";
            }
            setEditRow(editRow);
          }

          function handleStorageGroupIDtoName(selected){
            if(selected===""){
              return "none"
            }
            else{
              let id = storageGroupsList.filter(item => item.GroupID === selected)
              if(id.length===0){
                return ""
              }
              else{
                let val = id[0].GroupName
                if(val.charAt(0)==='_'){
                  val = val.substring(1);
                }
                return val;
              }
            } 
          }

          function handleStorageGroupOptions(data){
            let opt =[]
            data.map((val)=>{
              if(val.charAt(0)==='_'){
                val = val.substring(1);
              }
              opt.push(val);
            })
            return opt;
          }

          return(
            <Box sx={{display:"flex",flexDirection:"row", gap:'12px'}}>
              <CustomCheckbox defaultChecked={editable?editRow[0].storage:record.storage} disabled={editable?false:true} onChange={handleStorageCheck}/>
              {editable ? (
                <>
                  <CustomDropDown options={handleStorageGroupOptions(storageGroups)} disabled={editRow[0].storage.toString() === 'true' ? false : true} onChange={handleStorageGroupChange} defaultValue={handleStorageGroupIDtoName(editRow[0].storageGroupid)} width={"130px"}></CustomDropDown>  
                </>
              ) : (
                <Typography>{handleStorageGroupIDtoName(record.storageGroupid)}</Typography>
              )
              }
            </Box>
          )
        }
    },
    {
        title: 'Enable',
        dataIndex: 'active',
        width: '3.8%',
        // editable: true,
        render:(_text,record,index)=>{
          const editable = isEditing(record);
          function handleActiveCheck(selected){
            // dataSource.
            // const updatedDataSource = JSON.parse(JSON.stringify(dataSource));
            // updatedDataSource[index].active = selected.toString();
            // setDataSource(updatedDataSource);
            const updatedRow = JSON.parse(JSON.stringify(editRow));
            editRow[0].active = selected.toString();
            setEditRow(editRow);
          }
          return(
            <CustomCheckbox defaultChecked={editable?editRow[0].active:record.active} disabled={editable?false:true} onChange={handleActiveCheck}/>
          )
        }
    },
    {
    title: 'Operation',
    dataIndex: 'operation',
    width: '6.3%',
    render: (_, record,) =>
      {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key)}
              style={{
                marginInlineEnd: 8,
                color:"var(--LK_BrandBlue_1)"
              }}
            >
              Done
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link style={{color:editingKey !== ""? "var(--Searchtext_muted)": "var(--LK_BrandBlue_1)",}} disabled={editingKey !== ''} onClick={() => edit(record)}>
            Edit
          </Typography.Link>
        );
      }
    },
  ];
 
  const [columnData,setColumnData]=useState(defaultColumns)
 
  function getParametrs(data) {
      setColumnData(JSON.parse(JSON.stringify(defaultColumns)));
      const paralist= JSON.parse(JSON.stringify(data));
      setActiveParameter(paralist);
  }
 
  useEffect(()=>{
    const newdata = [...dataSource]
    setdata(newdata)
    getParametrs(newdata);
    if(deleteTags===1){
      getdeleteTags(newdata)
      setdeleteTags(0)
    }
  },[dataSource]);
 
  const handletabchange = (_event, newValue) => {
    setTabvalue(newValue);
  }
 
  useEffect(()=>{getParametrs(dataSource);},[tabvalue])
 
 
  const edit = record => {
    form.setFieldsValue({
      name: '',
      age: '',
      address: '',
      ...record,
    });
    setEditingKey(record.key);
    setEditRow([{...record}]);
  };
 
  const cancel = () => {
    setEditingKey('');
    setEditRow([{tagId:"",key: 0 ,parameter: '',datatype: dataTypesList[0][0],description: '',alias: '',unit: unit0,payloadName:'',value:'',timestamp: '',active: false,storage: false,storageGroupid:'',scalingFactor:''}]);
    const newData = [...dataSource];
    if(newData[newData.length-1].key===editingKey){
      if(newData[newData.length-1].tagId==="" && newData[newData.length-1].parameter===""){
        newData.pop();
        setDataSource(newData);
      }
    }
  };
 
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex(item => key === item.key);
      if(editRow[0].parameter!=="" && editRow[0].description!=="" && editRow[0].payloadName!==""){
        if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...editRow[0],
        });
        setDataSource(newData);
        setEditingKey('');
        } else {
          newData.push(editRow[0]);
          setDataSource(newData);
          setEditingKey('');
        }
        setEditRow([{tagId:"",key: 0 ,parameter: '',datatype: dataTypesList[0][0],description: '',alias: '',unit: unit0,payloadName:'',value:'',timestamp: '',active: false,storage: false,storageGroupid:'',scalingFactor:''}]);
      }else{
        setRequired(1)
      }
    } catch (errInfo) {
    }
  };
 
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    _record,
    _index,
    children,
    ...restProps
  }) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
 
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
 
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
 
  const handleDelete = () => {
    // let newData2 = [...deleteTags]
    let newData2 = []
    let temp = []
    {rowSelection.selectedRowKeys.map(val => {
          temp=dataSource.filter(item => item.key===val && item.tagId!=="")
          if(temp.length!==0){
            newData2 = [...newData2,temp[0].tagId];
          }
    })}
    // setdeleteTags(newData2)
    if(deviceId===''){
      tagdelcallback(newData2)
    }else{
      librarytagdelete(deviceId,newData2,tagdelcallback)
    }
  };

  function tagdelcallback(_res){
    let newData = dataSource
    {rowSelection.selectedRowKeys.map(val =>{
      newData = newData.filter(item => item.key!==val);
    })}
    setOperation(0);
    setSelectedRowKeys([]);
    setdeleteTags(1)
    setDataSource(newData);

  }
 
  useEffect(()=>{
    // getdeleteTags(deleteTags)
  },[deleteTags])

  const handleDeleteCancel = () => {
    setSelectedRowKeys([]);
    setOperation(0);
  };
 
  const handleAdd = () => {
    const count = dataSource.length!==0?(parseInt(dataSource[dataSource.length - 1].key,10) +1):0 ;
    const unit = unitsList[0]==="NA"?" ":unitsList[0];
    const newData = {
       tagId:"",
       key: count ,
       parameter: '',
       datatype: dataTypesList[0][0],
       description: '',
       alias: '',
       unit: unit,
       payloadName:'',
       value:'',
       timestamp: '',
       active: false,
       storage: false,
       storageGroupid:'',
       scalingFactor:''
    };
    form.setFieldsValue({
      tagId:"",
       key: count ,
       parameter: '',
       datatype: '',
       description: '',
       alias: '',
       unit: '',
       payloadName:'',
       value:'',
       timestamp: '',
       active: false,
       storage: false,
       storageGroupid:'',
       scalingFactor:''
    });
    setDataSource([...dataSource, newData]);
    setEditingKey(newData.key);
    setEditRow([{...newData}]);
  };
 
 
  const mergedColumns = (defaultColumns).map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
 
  function handleFilterSelected(selectedValue){
    search.filterSelected=selectedValue;
    setSearch(search);
  };
 
  function handleSearchText(selectedValue){
    search.searchText=selectedValue;
    setSearch(search);
  };
 
  function handleSearchCancel(){
    setSearch({searchText:"",filterSelected:""});
    setsearchList([]);
    setifSearching(0);
  };
 
  function handleSearchClick(){
    let temp = [];
    let templist = [...activeParameter];
    if(search.filterSelected!==""){
      const filterVal=Object.entries(filterMap).find(([_key, value]) => search.filterSelected.includes(value));
      setifSearching(1);
      let val="";
      if(search.filterSelected.includes("Enable")){
        val="true";
      }else if(search.filterSelected.includes("Disable")){
        val="false";
      }
      activeParameter.filter(value =>{
        Object.keys(value).forEach(key => {
          if (key === filterVal[0] && value[key] === val  ) {
            temp=[...temp,value];
          }
        });
        templist=[...temp];
      })
    }
    if(search.searchText!==""){
      setifSearching(1);
      temp = [];
      templist.filter(value=>{
        if(value.parameter.toLowerCase().includes(search.searchText.toLowerCase()) || value.alias.toLowerCase().includes(search.searchText.toLowerCase()) || value.description.toLowerCase().includes(search.searchText.toLowerCase()) || value.unit.toLowerCase().includes(search.searchText.toLowerCase()) || value.datatype.toLowerCase().includes(search.searchText.toLowerCase()) || value.payloadName.toLowerCase().includes(search.searchText.toLowerCase()) || value.scalingFactor.toLowerCase().includes(search.searchText.toLowerCase())){
            temp=[...temp,value];
        }
      })
    }
    setsearchList(temp);
  }; 
 
  function handleTimestamp(timeVal){
    const date = new Date(timeVal * 1000)
    const month = date.getMonth()+1;
    const timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
    return timestamp
  }

  function handleDisplayDataTypeName(selected){
    let name =""
    dataTypesList[0].forEach((item,index) => {
      if(item===selected){
        name = dataTypesList[1][index];
      }
    })
    return name;
}

function handleInternalDataTypeName(selected){
  let name =""
  dataTypesList[1].forEach((item,index) => {
    if(item===selected){
      name = dataTypesList[0][index];
    }
  })
  return name;
}
  
 function handleImportData(data){
  setifLoading(1);
  const headerList=["Parameter","Description","Alias","Data Type","Payload Name","Unit","Scaling Factor","Storage","Storage Group","Enable"];
  const fieldList = ["parameter","description","alias","datatype","payloadName","unit","scalingFactor","storage","storageGroupid","active"];
  let newData = [...dataSource]
  data.map(val=>{
    let ifpresent="";
    newData.map((value,ind) => {
        if(value.parameter===val.Parameter){
          ifpresent = ind;
        }
    });
    if(ifpresent!==""){
      for(let i=0;i<headerList.length;i++){
        const temp = {...newData[ifpresent]};
        temp[fieldList[i]]=val[headerList[i]];
        if(headerList[i]==="Storage Group"){
          if(val[headerList[i]]!=='none'){
            let id = storageGroupsList.filter(item => item.GroupName.charAt(0)==='_'? item.GroupName.substring(1) === val[headerList[i]] : item.GroupName === val[headerList[i]]);
            if(id.length===0){
              temp[fieldList[i]] = "";
            }
            else{
              temp[fieldList[i]] = id[0].GroupID;
            }
          }
          else{
            temp[fieldList[i]] = "";
          }
        }
        if(headerList[i]==="Storage" || headerList[i]==="Enable"){
          temp[fieldList[i]]=val[headerList[i]]==="Enabled"?'true':'false';
        }
        if(headerList[i]==="Unit"){
          temp[fieldList[i]]=val[headerList[i]]==="NA"?" ":val[headerList[i]];
        }
        if(headerList[i]==="Data Type"){
          temp[fieldList[i]]=handleInternalDataTypeName(val[headerList[i]]);
        }
        newData[ifpresent] = {...temp}
      }
    }
    else{
        const temp={tagId:"",key: 0,parameter: '',description:"",payloadName:"",datatype: '',timestamp: '',alias: '',value:'',unit: '',active: false,storage: false,storageId:[],storageGroupid:''}
        temp.key=newData.length;
        for(let i=0;i<headerList.length;i++){
          temp[fieldList[i]]=val[headerList[i]];
          if(headerList[i]==="Storage Group"){
            if(val[headerList[i]]!=='none'){
              let id = storageGroupsList.filter(item => item.GroupName.charAt(0)==='_'? item.GroupName.substring(1) === val[headerList[i]] : item.GroupName === val[headerList[i]]);
              if(id.length===0){
                temp[fieldList[i]] = "";
              }
              else{
                temp[fieldList[i]] = id[0].GroupID;
              }
            }
            else{
              temp[fieldList[i]] = "";
            }
          }
          if(headerList[i]==="Storage" || headerList[i]==="Enable"){
            temp[fieldList[i]]=val[headerList[i]]==="Enabled"?'true':'false';
          }
          if(headerList[i]==="Unit"){
            temp[fieldList[i]]=val[headerList[i]]==="NA"?" ":val[headerList[i]];
          }
          if(headerList[i]==="Data Type"){
            temp[fieldList[i]]=handleInternalDataTypeName(val[headerList[i]]);
          }
        }
        newData = [...newData,temp]
    }
  })
  setDataSource(newData);
  setifLoading(0);
 }

 function handleExportData(data){
  let dataToExport = data.filter(val => selectedRowKeys.includes(val.key))
  dataToExport = dataToExport.map((val)=>{
    let temp = {...val}
    if(val.storageGroupid===""){
      temp.storageGroupid="none"
    }else{
      let id = storageGroupsList.filter(item => item.GroupID === val.storageGroupid)
      if(id.length===0){
        temp.storageGroupid= "none"
      }
      else{
        if(id[0].GroupName.charAt(0)==='_'){
          temp.storageGroupid= id[0].GroupName.substring(1);
        }else{
          temp.storageGroupid= id[0].GroupName;
        }
      }    
    }
    temp.datatype = handleDisplayDataTypeName(val.datatype);
    temp.active= (val.active===true || val.active==='true') ? "Enabled" : "Disabled";
    temp.storage= (val.storage===true || val.storage==='true') ? "Enabled" : "Disabled";
    temp.unit= val.unit===" "?"NA":val.unit;
    return temp
 });
  return dataToExport;
 }
 
  return(
    <>
      <div style={{display: 'flex', flexDirection: 'row',width:"100%",boxSizing:"border-box",maxWidth:'100%'}}>
          <Tabs
              value={tabvalue}
              onChange={handletabchange}
              TabIndicatorProps={{ hidden: true }}
              sx={{
                  '& .MuiTabs-indicator': {
                      display: 'none',
                      height: '0px',
                      borderRadius: '0px',
                      backgroundColor: 'var(--action-button-light)',
                      borderBottom: "1px solid var(--SecondaryBackground)"
                  },
                  '& .Mui-selected': {
                      color: 'var(--LK_BrandBlue_1) !important',
                      fontWeight: '700 !important',
                      backgroundColor:'var(--SecondaryBackground)',
                      borderTop: "1px solid var(--HighlightedText_Stroke)",
                      borderLeft: "1px solid var(--HighlightedText_Stroke)",
                      borderRight: "1px solid var(--HighlightedText_Stroke)",
                      borderBottom: "1px solid var(--SecondaryBackground)",
                  },
                  '& .MuiTab-root': {
                      padding: '8px 8px 6px 8px !important',
                      margin: '0px !important',
                      minWidth: '63px',
                  },
                  minHeight: '30px',
                  marginBottom:'-1px'
              }}
          >
            {
                maintabs.map(tab => {
                    return(
                        <Tab
                            sx={{
                                minHeight: '30px',
                                height: '30px'
                            }}
                            style={{
                                color: 'var(--GreyVariation_2)',
                                fontFamily: 'Roboto',
                                fontSize: '14px',
                                fontWeight: 400,
                                lineHeight: '16.75px',
                                textTransform: 'capitalize'
                            }}
                            value={tab}
                            label={tab}
                        >
                            {tab}
                        </Tab>
                    )
                })
            }
          </Tabs>
      </div>
      <Box style={{display: 'flex', flexDirection: 'row',backgroundColor:"var(--SecondaryBackground)",padding:"8px" ,width:"100%",maxWidth:'100%',boxSizing:"border-box",border: "1px solid var(--HighlightedText_Stroke)" ,}} >
        <Box style={{display: 'flex', flexDirection: 'column',width:"100%",boxSizing:"border-box",maxWidth:'100%',gap:"16px"}}>
          <Box style={{alignContent:"center"}} sx={{display:'flex',flexDirection:'row',width:"100%",boxSizing:"border-box",alignItems:"center",gap:"8px",}}>
            <Box sx={{flexGrow:1}}/>
            {tabvalue==="Parameter List"?
              <>
                <CustomExportButton data={handleExportData(dataSource)} fileName="myData.csv" headerList={["Parameter","Description","Alias","Data Type","Payload Name","Unit","Scaling Factor","Storage","Storage Group","Enable"]} fieldList={["parameter","description","alias","datatype","payloadName","unit","scalingFactor","storage","storageGroupid","active"]}/>
                <CustomImportButton setData={handleImportData}/>
                <CustomTooltip title={"Add"} offset={[30,-20]} placement={'right-end'}>
                  <Button
                    onClick={handleAdd}
                    disabled={editingKey!==''?true:false}
                    type="text"
                    style={{
                      marginRight:'-4px',
                      marginBottom: "0px",
                      marginTop:"0px",
                      color:"#008CD7",
                      alignSelf:"center",
                      justifySelf:"end",
                      minWidth: "32px",
                      padding:0,
                    }}
                  >
                    <LK_Add color={editingKey!==''?theme === 'light' ? '#C1C1C1' : '#3C3C3C':'var(--LK_BrandBlue)'} width={"28px"} height={"28px"}/>
                  </Button>
                </CustomTooltip>
                {/* {hasSelected && operation==0? */}
                  <CustomTooltip title={"Delete"} offset={[30,-20]} placement={'right-end'}>
                    <Button
                        onClick={()=>setOperation(rowSelection.selectedRowKeys.length>0?1:2)}
                        type="text"
                        style={{
                        marginRight:'0px',
                        marginBottom: 0,
                        color:"#008CD7",
                        padding:0,
                        minWidth: "32px",
                        }}
                    >
                        <LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/>
                    </Button>
                  </CustomTooltip>
                  {/* :
                  <></>
                } */}
                <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Are you sure you want to delete "+ rowSelection.selectedRowKeys.length + " tag" + (rowSelection.selectedRowKeys.length>1?"s":"")} openDialog={operation===1} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDelete} confirmText={"Yes"} cancelText={"No"} type={"Warning"}/>
                <CustomDialogBox dialogTitle={"Delete Conformation"} dialogText={"Please select devices for deletion"} openDialog={operation===2} handleCloseDialog={handleDeleteCancel} handleConfirmDialog={handleDeleteCancel} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                <CustomDialogBox dialogTitle={"Required fields to be filled"} dialogText={"Please fill required fields"} openDialog={required===1} handleCloseDialog={() => setRequired(0)} handleConfirmDialog={() => setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
              </>
            :
              <></>
            }
            <Box sx={{display:'flex', flexDirection:'row',width:'auto',fontSize:"16px",fontFamily:"Roboto",margin:"0px",alignSelf:"center" ,gap:"20px", alignItems:"center"}}>
              <CustomTextField id={'negative-feedback'} onChange={handleSearchText} defaultValue={ifsearching===0?"":search.searchText} placeholder={"search"} width={180}/>
              <CustomDropDown options={filter} onChange={handleFilterSelected} defaultValue={ifsearching===0?"":search.filterSelected} width={"150px"}></CustomDropDown>  
              <CustomTooltip title={"Search"} offset={[30,-20]} placement={'right-end'}>
                <Button onClick={handleSearchClick} style={{ fontSize: '12px',width:"40px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-24px",padding:0}}><LK_Search color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
              </CustomTooltip>
              {ifsearching===1?<Button onClick={handleSearchCancel} style={{ fontSize: '12px',width:"10px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-44px",padding:0}}><LK_Close color='var(--LK_BrandBlue)' width={"24px"} height={"24px"}/></Button>:<></> }
            </Box>
          </Box>
          <Form form={form} component={false} style={{width:"100%",boxSizing:"border-box",maxWidth:'100%'}}>
            <ConfigProvider
                theme={{
                    token: {
                        borderRadius: 0,
                        colorText: 'var(--grey-variation-tablerowsLK)',
                        colorTextHeading: 'var(--grey-variation-tablerowsLK)',
                        //fontFamily: props.widgetprop.props.extended.tablerows.fonttype,
                        fontSizeIcon: 10,
                        //colorBgContainer: '#EDEFEE',
                        lineHeight: 1.5,
                        boxSizing:"border-box",
                        // width:'100%',
                        // maxWidth:'100%'
                    },
                    components: {
                        Table: {
                            borderColor: 'var(--table-boarder-line)',
                            headerBg: "var(--SecondaryBackground)",
                            headerSplitColor: "var(--SecondaryBackground)",
                            colorBgContainer: 'var(--SecondaryBackground)',
                            rowHoverBg: 'var(--primary-background-color-hover)',
                            stickyScrollBarBg: 'var(--primary-background-color),var(--secondary-background)',
                            stickyScrollBarBorderRadius: 0,
                            //cellFontSizeSM: props.widgetprop.props.extended.tablerows.fontsize,
                            cellPaddingBlockSM: '7.05px',
                            cellPaddingInlineSM: '7.1px',
                            width:'100%',
                            maxWidth:'100%',
                            boxSizing:"border-box",
                        },
                    },
                }}
                style={{width:"100%",boxSizing:"border-box",maxWidth:'100%'}}
            >
              <Table
                  components={
                    {
                      body: {
                        cell: EditableCell,
                      },
                    }
                  }
                  rowSelection={rowSelection}
                  bordered={false}
                  tableLayout="fixed"
                  size='small'
                  pagination={false}
                  style={{
                    marginLeft: "2px",
                    marginRight: "2px",
                    marginTop: 0,
                    marginBottom: 0,
                    //height: "200px",
                    // width: 'calc(100% - 4px)',
                    width: '99%',
                    maxWidth:'100%',
                    boxSizing:"border-box",
                    tableLayout:'fixed',
                    backgroundColor: '#EDEFEE',
                    boxSizing:"border-box",
                  }}
                  rowClassName={() => 'editable-row'}
                  dataSource={ifsearching===0?activeParameter:searchList}
                  columns={mergedColumns}
                  scroll={{
                      y: '410px',
                  }}
                  notFoundContent={"No Data"}
                  locale={{ emptyText: (<span style={{color:"var(--GreyBaseColor)"}}> {ifloading!==1?<Typography style={{color:"var(--GreyBaseColor)",fontSize:"44px",fontFamily:'Roboto',margin:"32px 0px"}}>No Data</Typography>:<img src={LK_Loading} alt="loading..." style={{height:"64px" ,width:"auto",alignSelf:"center",margin:"32px 0px"}} />}
                    {/* <Button>do something</Button> */}
                    {/* <img src="https://www.baidu.com/img/bd_logo1.png" /> */}
                    </span>)
                   }}
              />
            </ConfigProvider>
          </Form>
        </Box>
      </Box>    
    </>
  )
}
 
 
 